module.exports = __webpack_public_path__ + "static/block6-a802679128ea1f10f2095ea2d2c7e9f0.jpg";